import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import serverList from "../../../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { payUserRank } from "@/api/data";
export default {
  components: {
    serverList: serverList
  },
  props: {
    titleType: Number
  },
  mixins: [infoList],
  data: function data() {
    return {
      //返回过来的数据
      listApi: payUserRank,
      searchInfo: {
        grouping: this.titleType == 2 ? "open_id" : "role_id",
        server_id: []
      },
      inputNum: ""
    };
  },
  methods: {
    checkPage: function checkPage() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (/^[0-9]*[1-9][0-9]*$/.test(_this.inputNum)) {
                _context.next = 5;
                break;
              }
              _this.inputNum = "";
              _this.$message({
                message: "页码应该是正整数",
                type: "warning"
              });
              _context.next = 8;
              break;
            case 5:
              _this.pageSize = _this.inputNum;
              _context.next = 8;
              return _this.getTableData();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    open2: function open2() {
      this.$notify({
        title: "充值排行",
        message: "(1)查询历史总充值排行，可选择按账号或者角色维度查询。" + "(2)可选择服务器，打开默认选中全部服务器，但不查询，需要手动点查询后再展示数据，根据总充值金额倒序排列。" + "(3)数据列包括排名、账号、角色Id，角色名、区服、等级、充值金额、注册时间、最后登录时间。",
        duration: 0
      });
    }
  }
};